import { z } from 'zod';
import { TranslationValidatorSchema } from './translation.validator';

export const AdminInterestCategoryValidatorSchema = z.object({
  name: z.array(TranslationValidatorSchema).min(1),
});

export type AdminInterestCategoryValidator = z.infer<
  typeof AdminInterestCategoryValidatorSchema
>;

export const AdminInterestValidatorSchema = z.object({
  categoryId: z.string().min(1),
  name: z.array(TranslationValidatorSchema).min(1),
});

export type AdminInterestValidator = z.infer<
  typeof AdminInterestValidatorSchema
>;

export const ReorderValidatorSchema = z.object({
  orderedIds: z.array(z.string()).min(1),
});

export type ReorderValidator = z.infer<typeof ReorderValidatorSchema>;

export const AdminFanAttributeValidatorSchema = z.object({
  name: z.string().min(1),
  aliases: z.array(z.string()),
  interestId: z.string().nullable(),
});

export type AdminFanAttributeValidator = z.infer<
  typeof AdminFanAttributeValidatorSchema
>;
